import React from "react";
import Loader from "./index";

interface LoadingOverlayProps {
  isLoading: boolean;
  text?: string;
  className?: string;
}

/**
 * Full overlay loader that covers the entire container
 * Use for page-level loading states
 */
export default function LoadingOverlay({
  isLoading,
  text,
  className = "",
}: LoadingOverlayProps) {
  if (!isLoading) return null;

  return (
    <div
      className={`fixed inset-0 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm z-50 flex items-center justify-center ${className}`}
    >
      <Loader size="lg" text={text} />
    </div>
  );
}

/**
 * Inline loader for containers
 * Use for section-level loading states
 */
export function InlineLoader({
  isLoading,
  text,
  className = "",
  size = "md",
}: {
  isLoading: boolean;
  text?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
}) {
  if (!isLoading) return null;

  return (
    <div className={`py-12 flex items-center justify-center ${className}`}>
      <Loader size={size} text={text} />
    </div>
  );
}

/**
 * Table row loader
 * Use for table loading states
 */
export function TableLoader({ colSpan }: { colSpan: number }) {
  return (
    <tr>
      <td colSpan={colSpan} className="py-12">
        <div className="flex items-center justify-center">
          <Loader size="md" text="Loading..." />
        </div>
      </td>
    </tr>
  );
}


